<script>
    import { onMount, onDestroy } from "svelte";
	import { t } from '$lib/translations';
	
	import LeftBtn from "$lib/images/slider/arrow-left.svg";
	import RightBtn from "$lib/images/slider/arrow-right.svg";

	import SlideHero1 from "$lib/images/slider/slide_1/hero.webp";
	import SlideMask1 from "$lib/images/slider/slide_1/mask.webp";

	import SlideHero2 from "$lib/images/slider/slide_2/hero.webp";
	import SlideMask2 from "$lib/images/slider/slide_2/mask.webp";

	import SlideHero3 from "$lib/images/slider/slide_3/hero.webp";
	import SlideMask3 from "$lib/images/slider/slide_3/mask.webp";

	import SlideHero4 from "$lib/images/slider/slide_4/hero.webp";
	import SlideMask4 from "$lib/images/slider/slide_4/mask.webp";

	let activeSlide = 0;
	// let interval;

	let slides = []

	$: if ($t && SlideHero1 && SlideMask1) {
		slides = [
			{
				id: 1,
				title: $t("home.slide_one_title"),
				description: $t("home.slide_one_description"),
				hero: SlideHero1,
				mask: SlideMask1,
				alt: $t("home.slide_one_alt")
			},
			{
				id: 2,
				title: $t("home.slide_two_title"),
				description: $t("home.slide_two_description"),
				hero: SlideHero2,
				mask: SlideMask2,
				alt: $t("home.slide_two_alt")
			},
			{
				id: 3,
				title: $t("home.slide_three_title"),
				description: $t("home.slide_three_description"),
				hero: SlideHero3,
				mask: SlideMask3,
				alt: $t("home.slide_three_alt")
			},
			{
				id: 4,
				title: $t("home.slide_four_title"),
				description: $t("home.slide_four_description"),
				hero: SlideHero4,
				mask: SlideMask4,
				alt: $t("home.slide_four_alt")
			}
		];
	}

	function nextSlide() {
		activeSlide = (activeSlide + 1) % slides.length;
	}

	function prevSlide() {
		activeSlide = (activeSlide - 1 + slides.length) % slides.length;
	}

	// function startAutoSlide() {
	// 	interval = setInterval(() => {
	// 		nextSlide();
	// 	}, 15000);
	// }
	//
	// onMount(() => {
	// 	// startAutoSlide();
	// });

	// onDestroy(() => {
	// 	clearInterval(interval);
	// });
</script>

<section>
	<div class="slider-wrapper">
		<div class="slides" style="transform: translateX(-{activeSlide * 100}%)">
			{#if slides && slides.length > 0}
				{#each slides as slide}
					<div class="slide">
						<div class="content">
							<div class="hero-image">
								<img src={slide.hero} alt="{slide.alt} hero">

								<div class="mask">
									<div class="text">
										<div class="title">
											{@html slide.title}
										</div>
										<div class="description">
											{slide.description}
										</div>
									</div>
									<div class="image">
										<img src={slide.mask} alt="{slide.alt} mask">
									</div>
								</div>
							</div>
						</div>
					</div>
				{/each}
			{/if}
		</div>
		<div class="controls">
			<button class="control-btn" on:click={prevSlide}>
				<img src={LeftBtn} alt="LeftBtn">
			</button>
			<button class="control-btn" on:click={nextSlide}>
				<img src={RightBtn} alt="RightBtn">
			</button>
		</div>
	</div>
</section>


<style lang="scss">
	@import "/src/lib/scss/main";

	$hero-width: 25rem;
	$mask-width: 40rem;

    .slider-wrapper {
        width: 100%;
        overflow: hidden;
        position: relative;
    }

    .slides {
        display: flex;
        transition: transform 0.5s ease;
    }

    .slide {
		flex: 0 0 100%;
		display: flex;
		justify-content: center;
		width: 100%;

		& > .content {
			display: flex;
			width: min-content;
			transform: scale(1);

			& > .hero-image {
				display: flex;
				position: relative;
				width: calc($hero-width + $mask-width - 8rem);

				& > img {
                    width: $hero-width;
				}

				& > .mask {
					width: 40rem;
					position: absolute;
					z-index: -1;
					margin-top: 4rem;
					left: 30%;

					& > .image {
						& > img {
							width: $mask-width;
						}
					}

					& > .text {
						display: flex;
						flex-direction: column;
						gap: 15px;
						margin-left: 4rem;

						& > .title {
							font-style: italic;
							font-weight: 300;
							font-size: 38px;
							color: #fff;
						}

						& > .description {
							font-weight: 200;
							font-size: 18px;
							line-height: 133%;
							color: rgba(255, 255, 255, 0.4);
							margin-left: 2rem;
						}
					}
				}
			}
		}
    }

	span.bolder {
		font-weight: 500!important;
	}

    .controls {
		display: flex;
		justify-content: space-between;
		position: absolute;
		top: 40%;
		width: 100%;
		padding: 0 3rem;
    }

    .control-btn {
		border: 1px #818181 solid;
		border-radius: 100%;
		background-color: #0f0f0f;
		outline: none;
		cursor: pointer;
        width: 60px;
		height: 60px;
		transition: box-shadow $default-transition-time;

		&:hover {
			box-shadow: #818181 0 0 5px 1px;
		}
    }

	@media screen and (max-width: 1200px) {
		.content {
			transform: scale(0.8)!important;
		}
	}

	@media screen and (max-width: 950px) {
		.content {
			transform: scale(0.7)!important;
		}
		.control-btn {
			width: 50px!important;
			height: 50px!important;
		}
	}

	@media screen and (max-width: 870px) {
		.content {
			transform: scale(0.6) !important;
		}
	}

	@media screen and (max-width: 700px) {
		section {
			display: none!important;
		}
		.content {
			transform: scale(0.5) !important;
		}
		.control-btn {
			display: none!important;
		}
    }

	@media screen and (max-width: 470px) {
		.content {
			transform: scale(0.4) !important;
		}
	}

	@media screen and (max-width: 360px) {
		.content {
			transform: scale(0.3) !important;
		}
    }

</style>